import { Link } from "react-router-dom";
import { FiShoppingBag, FiScissors, FiEdit, FiPackage } from "react-icons/fi";
import { SECTION_LABELS } from "@/config/constants";
import { ROUTES } from "@/routes/paths";
import { useExploreStore } from "@/features/explore";

const ACTIONS = [
  { to: ROUTES.PRODUCTS, label: "Browse products", icon: FiShoppingBag },
  { to: ROUTES.DESIGNERS, label: "Browse designers", icon: FiScissors },
  { to: ROUTES.CUSTOM_ORDERS, label: "Custom order", icon: FiEdit },
  { to: ROUTES.ORDERS, label: "My orders", icon: FiPackage },
];

/** Landing page. No account, so nothing here depends on who is looking. */
export function HomePage() {
  const section = useExploreStore((s) => s.section);

  return (
    <div className="space-y-8">
      <div className="rounded-lg border border-border bg-card p-6 text-card-foreground">
        <h1 className="text-2xl font-bold text-foreground">Cross Border</h1>
        <p className="mt-1 text-muted-foreground">
          Order Pakistani designer fashion and North American products, delivered across
          borders. No account needed — we email you a private link to follow your order.
        </p>
        {section && (
          <p className="mt-2 text-sm text-muted-foreground">
            Browsing: {SECTION_LABELS[section] ?? section}
          </p>
        )}
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        {ACTIONS.map((a) => (
          <Link
            key={a.to}
            to={a.to}
            className="flex items-center gap-3 rounded-lg border border-border bg-card p-4 text-card-foreground transition-colors hover:border-primary hover:bg-secondary"
          >
            <a.icon className="text-primary" size={22} />
            <span className="font-medium text-foreground">{a.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default HomePage;
